import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";
var SvgCheckmark = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, props = __rest(_a, ["size"]);
    return (React.createElement(Svg, __assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 0C5.39 0 0 5.39 0 12s5.39 12 12 12 12-5.39 12-12S18.61 0 12 0zm6.703 8.719l-7.969 7.969a.954.954 0 01-.703.28.954.954 0 01-.703-.28l-3.984-3.985a1.02 1.02 0 010-1.406 1.02 1.02 0 011.406 0l3.281 3.281 7.266-7.265a1.02 1.02 0 011.406 0 1.02 1.02 0 010 1.406z" })));
};
export default SvgCheckmark;
//# sourceMappingURL=Checkmark.js.map